import { getJson, postJson } from './client'
import type { CorrectionView } from '../types/corrections'
import type { ImproveOverview, ImprovementRun, LedgerView, Rule, RuleRequest, RunNowResponse } from '../types/improve'

// The self-improvement loop, read and steered. Nothing here computes: the tallies, the verdicts and the
// outcome sentence all arrive decided from the API. Stating a rule by hand does NOT activate it — it
// records a `manual` correction carrying the proposal, which tonight's run verifies like any other.
const improve = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/improve`

export const improveApi = {
  overview: (spoke: string) => getJson<ImproveOverview>(improve(spoke)),
  /** Every correction with the level it was addressed at and what else that moved — decided server-side. */
  ledger: (spoke: string) => getJson<LedgerView>(`${improve(spoke)}/ledger`),
  runs: (spoke: string, take?: number) => getJson<ImprovementRun[]>(`${improve(spoke)}/runs`, { take }),
  rules: (spoke: string, active?: boolean) => getJson<Rule[]>(`${improve(spoke)}/rules`, { active: active === undefined ? undefined : String(active) }),
  /** Goes on the ledger as a manual correction; verified tonight like anything the loop proposed itself. */
  addRule: (spoke: string, body: RuleRequest) => postJson<CorrectionView>(`${improve(spoke)}/rules`, body),
  /** Retiring a rule is itself a correction, so it carries a required reason. */
  retireRule: (spoke: string, ruleId: string, reason: string) =>
    postJson<Rule>(`${improve(spoke)}/rules/${encodeURIComponent(ruleId)}/retire`, { reason }),
  /** Admin only: runs the self-improve job now rather than waiting for the night. 202 + the job. */
  runNow: (spoke: string) => postJson<RunNowResponse>(`${improve(spoke)}/run`),
}
